<div [ngStyle]="backgroundStyle"  class="modal-header">
    <h4 style="color: white;" class="modal-title pull-left"> Assign Teacher to Subject : <a style="font-weight : bold">{{name}}</a></h4> 
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeUpdateModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div> 
   


  <div class="modal-body">
    <div class="card">
      <div class="card-body"> 
      <form (ngSubmit)="onSubmit()"  #clsForm="ngForm"> 



        <div class="form-group row">


          <div class="col-md-6">
            <label class="required" for="fkSubject">Subject</label> <br>
                <select required  class="form-control" [(ngModel)]="teacher.fkSubject" id="fkSubject" name="fkSubject">
                  <option value="" disabled >Choose Subject</option>
                  <option  *ngFor="let subject of subjects"  [ngValue]="subject.subId">{{subject.name}}</option>
                </select>
            </div>
            
            <div class="col-md-6">

        <label class="required" for="fkUserRoleOffice">Teacher</label> <br>
            <select required  class="form-control" [(ngModel)]="teacher.fkUserRoleOffice" id="fkUserRoleOffice" name="fkUserRoleOffice">
              <option value="" disabled >Choose User</option>
              <option  *ngFor="let user of users"  [ngValue]="user.id">{{user.userName}}</option>
            </select>
        </div>

        

      

        </div>

           

    
</form>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button  [disabled]="clicked"  [disabled]="!clsForm.valid" class="btn btn-sm btn-primary float-right" (click)="onSubmit();clicked=true">Add</button>
  </div>
